import { ProgressTimelineDto } from "../../dtos/ProgressTimelineDto";
import { ApiResult, apiWrapperWithError } from "./ApiUtils";

export const getProgressTimelineData = async (grantId: string): Promise<ApiResult<ProgressTimelineDto> | null> => {
    return apiWrapperWithError<ProgressTimelineDto>(`api/progress-timeline/grant/${grantId}`, 'GET', `fetching progress timeline data for grant ${grantId}`);
};
